import React, {useCallback} from 'react';
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import Div from "@jumbo/shared/Div";
import { useDebouncedCallback } from "beautiful-react-hooks";

const InputSearch = ({ onChange = (e) => { return e }, onBlur, onEnter, value, sx }) => {
    const [searchKeywords, setSearchKeywords] = React.useState();
    const handleChange = useDebouncedCallback((event) => {
        setSearchKeywords(event.target.value);
    });
    const handleChangeBlur = useDebouncedCallback((event) => {
        window.scrollTo(0, -65);
        onBlur(event.target.value);
    });

    React.useEffect(() => {
        onChange(searchKeywords);
    }, [searchKeywords]);

    React.useEffect(() => {
        return () => handleChange.cancel();
    });
    
    const handleKeyDown = useCallback(
        (event) => {
          if (event.key === 'Enter') {
            onEnter(searchKeywords); // Call the onEnter function with the searchKeywords
          }
        },
        [onEnter, searchKeywords]
      );

    return (
        <Div sx={{
            position: 'relative',
            width: '100%',
            ...sx
        }}>
            <Div sx={{
                padding: theme => theme.spacing(0, 2),
                height: '100%',
                position: 'absolute',
                pointerEvents: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2,
                right: 0,
                color: '#606060'
            }}>
                <SearchIcon />
            </Div>
            <InputBase
                sx={{
                    color: 'inherit',
                    display: 'flex',
                    borderRadius: 24,
                    backgroundColor: '#ffffff',
                    boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.14)',

                    '& .MuiInputBase-input': {
                        padding: theme => theme.spacing(1, 1, 1, 0),
                        // vertical padding + font size from searchIcon
                        paddingRight: theme => `calc(1em + ${theme.spacing(4)})`,
                        paddingLeft: theme => theme.spacing(3),
                        transition: theme => theme.transitions.create('width'),
                        width: '100%',
                        height: 24
                    },
                }}
                placeholder="Cari"
                inputProps={{ 'aria-label': 'search' }}
                onChange={handleChange}
                onBlur={handleChangeBlur}
                value={value}
                onKeyDown={handleKeyDown}
            />
        </Div>
    );
};

export default React.memo(InputSearch);
